import React from 'react';
import PropTypes from 'prop-types';

import Pm from 'app/helpers/rich-text/prose-mirror';

class RteViewer extends React.PureComponent {

  render() {
    const {fontSize, md} = this.props;
    const html = md ? Pm.mdToHtml(md) : '';
    const className = `rte-view font-size-${fontSize}`;

    return (
      <div className={className} dangerouslySetInnerHTML={{__html: html}} />
    );
  }

}

RteViewer.propTypes = {
  md: PropTypes.string,
  fontSize: PropTypes.oneOf(['normal', 'large']),
};

RteViewer.defaultProps = {
  md: '',
  fontSize: 'normal',
};

export default RteViewer;
